import { generateId } from '@okee-uikit/react-utils';
import { useConst } from './const';
export function useId(scope, providedId) {
  return useConst(function () {
    return providedId || generateId(scope);
  });
}